import { RiAlertFill } from 'react-icons/ri';

import { AlertProps, Alert } from '@ui';

export interface DittoAlertProps extends AlertProps {
  // remove it once we have updated to use mantine props everywhere
  // type: 'success' | 'warning' | 'info' | 'error' | 'info-2';
  message: string | React.ReactNode;
  dangerousHtml?: boolean;
}

const DittoAlert: React.FC<DittoAlertProps> = ({
  message,
  dangerousHtml,
  icon = <RiAlertFill size={20} />,
  ...rest
}) => {
  // const getColors = () => {
  //   let bgColor = '#FEF4E2';
  //   let iconColor = '#966316';

  //   if (type === 'warning') {
  //     bgColor = '#FEF4E2';
  //     iconColor = '#966316';
  //   } else if (type === 'success') {
  //     bgColor = 'rgb(239, 247, 233)';
  //     iconColor = 'rgb(91, 158, 40)';
  //   } else if (type === 'info') {
  //     bgColor = '#F7F9FA';
  //     iconColor = '#3DABF5';
  //   } else if (type === 'error') {
  //     bgColor = '#FAE6E6';
  //     iconColor = '#F24C4C';
  //   } else if (type === 'info-2') {
  //     bgColor = 'rgba(30, 201, 255, 0.1)';
  //     iconColor = '#3DABF5';
  //   }

  //   return { bgColor, iconColor };
  // };

  // const colors = getColors();

  // return (
  //   <Box bg={colors.bgColor} style={{ borderRadius: 8, padding: '8px 12px' }}>
  //     <Group gap="xs" wrap="nowrap" align="start">
  //       {!customIcon ? (
  //         <RiAlertFill
  //           size={20}
  //           color={colors.iconColor}
  //           style={{ flexShrink: 0 }}
  //         />
  //       ) : (
  //         customIcon
  //       )}
  //       <Text size="sm" style={{ fontSize: '0.75rem' }}>
  //         {!dangerousHtml ? (
  //           message
  //         ) : (
  //           <span dangerouslySetInnerHTML={{ __html: message as string }} />
  //         )}
  //       </Text>
  //     </Group>
  //   </Box>
  // );

  return (
    <Alert w="100%" icon={icon} {...rest}>
      {!dangerousHtml ? (
        message
      ) : (
        <span dangerouslySetInnerHTML={{ __html: message as string }} />
      )}
    </Alert>
  );
};

export { DittoAlert };
